import { useCallback, useEffect, useState } from "react";
import { copyToClipboard } from "../utils/clipboardUtils";

export const COPIED_CONFIRMATION_MS = 2000;

// For a copy button that briefly confirms the copy: copy(text) writes to the
// clipboard and copied stays true for confirmationMs afterwards. copied stays
// false when the browser has no clipboard or refuses the write.
const useCopyToClipboard = (confirmationMs = COPIED_CONFIRMATION_MS) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), confirmationMs);
    return () => clearTimeout(timer);
  }, [copied, confirmationMs]);

  const copy = useCallback(async (text) => {
    const didCopy = await copyToClipboard(text);
    setCopied(didCopy);
    return didCopy;
  }, []);

  return [copied, copy];
};

export default useCopyToClipboard;
